import { useAppRouter } from '@/common/route/useAppRouter';
import { useCrudActions } from '@/common/view/useCrudActions';
import { ROUTE_NAME_ARENA } from '@/modules/arena/router';
import { arenaService } from '@/services/arena';
import useVuelidate from '@vuelidate/core';
import { required } from '@vuelidate/validators';
import { reactive } from 'vue';
import { useRoute } from 'vue-router';

export function useArenaTicketAdd() {
    const route = useRoute();
    const router = useAppRouter();
    const { executeAction, excuteAndNotify, confirmAndRemove } = useCrudActions();

    const model = reactive({
        type: Number(route.params.type),
        name: '',
        canDelete: false
    });

    const validations = {
        name: { required }
    };

    const v$ = useVuelidate(validations, model);

    const fetch = executeAction({
        request: () => arenaService.ticket.get(model.type),
        onSuccess: ({ data }) => Object.assign(model, data),
        onError: () => router.push({ name: ROUTE_NAME_ARENA.TICKET.INDEX })
    });

    const actions = {
        update: excuteAndNotify({
            validator: v$,
            request: () => arenaService.ticket.update(model.type, model.name),
            onSuccess: () => router.push({ name: ROUTE_NAME_ARENA.TICKET.INDEX })
        }),
        remove: confirmAndRemove({
            request: () => arenaService.ticket.remove(model.type),
            onSuccess: () => router.push({ name: ROUTE_NAME_ARENA.TICKET.INDEX })
        })
    };

    return { model, v$, fetch, actions };
}
